var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12","center":""}},[_c('v-row',_vm._l((_vm.places),function(images,index){return _c('div',{key:index,staticClass:"pa-2"},[(_vm.loaded)?_c('v-img',{attrs:{"height":"200px","width":"200px","src":`${images.images}`}}):_vm._e()],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }